import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaEye } from 'react-icons/fa';

import axios from '../../api/axios';
import BottomNav from '../../components/BottomNav';
import HeaderWithBack from '../../components/HeaderWithBack';
import { useAuth } from '../../contexts/AuthContext';
import Loading from '../../components/Loading';

const ReferenceList: React.FC = () => {
  const navigate = useNavigate();
  const [references, setReferences] = useState<any>([]);
  const { token: authToken, user: userData } = useAuth();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!authToken || !userData?.id) return;

    const fetchData = async () => {
      setIsLoading(true);
      try {
        const res = await axios.get('reference', {
          params: { user_id: userData.id },
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        setReferences(res.data.data || []);
      } catch (error) {
        console.error('Error fetching references:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [authToken, userData?.id]);

  // Function to determine status badge color
  const getStatusColor = (status: string) => {
    switch (status?.toLowerCase()) {
      case 'active':
      case 'approved':
        return 'bg-green-500';
      case 'pending':
        return 'bg-yellow-500';
      case 'expired':
      case 'rejected':
        return 'bg-red-500';
      default:
        return 'bg-gray-500';
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <HeaderWithBack title="Rujukan" />

      {/* Profile Box */}
      <div className="bg-white p-4">
        <div className="bg-gray-100 rounded-md p-3 flex items-center justify-between shadow-sm">
          <div className="flex items-center">
            <div className="w-8 h-8 rounded-full bg-gray-300 mr-3" />
            <span className="font-medium">
              {userData ? userData.person.name : ""}
              <span className="text-sm text-gray-500"> (Me)</span>
            </span>
          </div>
        </div>
      </div>

      {/* List of References */}
      {isLoading ?
        <div className="flex-1 flex items-center justify-center">
          <Loading />
        </div>
        :
        <div className="px-4 pb-20">
          {references.length === 0 ? (
            <div className="text-center text-gray-500 mt-10">
              Tidak ada rujukan
            </div>
          ) : (
            references.map((item: any, index: number) => (
              <div key={index} className="mb-4">
                <div className="bg-teal-500 text-white px-3 py-1 rounded-t-md text-sm font-medium flex items-center justify-between">
                  <span>{item.reference_date}</span>
                  <span className={`text-xs px-2 py-1 rounded pending`}>
                    Menunggu Approval
                  </span>
                </div>
                <div className="border rounded-b-md p-4 shadow-sm">
                  <p className="font-semibold">No. Rujukan: {item.reference_number}</p>
                  <p className="font-medium mt-1">{item.provider_name}</p>
                  <p className="text-sm text-gray-600">{item.poly_name || item.poly}</p>

                  <div className="text-sm mt-2 mb-3 border-l-2 border-gray-300 pl-3">
                    <p>Tipe: {item.type}</p>
                    <p>Poli: {item.poly_code}</p>
                    <p>Batas Berlaku: {item.reference_expired_date}</p>
                  </div>

                  {item.doctor_note && (
                    <div className="text-sm bg-gray-50 p-2 rounded mb-3">
                      <p className="font-medium text-gray-700">Catatan Dokter:</p>
                      <p className="text-gray-600">{item.doctor_note}</p>
                    </div>
                  )}

                  <button
                    className="bg-teal-500 text-white flex items-center px-4 py-1 rounded-md text-sm hover:bg-teal-600"
                    onClick={() => navigate(`/reference/${item.id}`)}
                  >
                    <FaEye className="mr-2" /> Lihat Detail
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      }

      {/* Bottom Navigation */}
      <BottomNav />
    </div>
  );
};

export default ReferenceList;